import { fetchAddressList } from '@/services';
import type { AnyObj, AnyObjOrNull } from '@/types';
import { defineStore } from 'pinia';

interface State {
  /** 地址列表 */
  addressList: any[];
  /** 地址编辑数据 */
  addressEditData: any;
  /** 选定地址后的回调函数 */
  selectedAfterCallback: ((selectedItem: AnyObj) => void) | null;
  /** 新增、编辑操作后的id，用于修改地址页操作成功后勾选对应项 */
  afterHandleId: string;
  /** 修改地址时顶部显示的地址 */
  displayedAddress: AnyObjOrNull;
}

export const useAddressStore = defineStore('address', {
  state: (): State => ({
    addressList: [],
    addressEditData: null,
    selectedAfterCallback: null,
    afterHandleId: '',
    displayedAddress: null,
  }),

  getters: {
    defaultAddress(state) {
      if (!state.addressList?.length) return null;

      const item = state.addressList.filter((it) => it?.defaultShippingAddress)?.[0];
      if (!item) {
        return state.addressList[0];
      }
      return item;
    },
  },

  actions: {
    async getAddressList(refresh?: boolean) {
      if (!this.addressList.length || refresh) {
        const data = await fetchAddressList();
        if (data) this.addressList = data;
      }
      return this.addressList;
    },
    setEdits(data: any) {
      this.addressEditData = data;
    },
  },
});
